import { render } from "./ImpressPage.vue?vue&type=template&id=2907dded&scoped=true"
import script from "./ImpressPage.vue?vue&type=script&lang=js"
export * from "./ImpressPage.vue?vue&type=script&lang=js"

import "./ImpressPage.vue?vue&type=style&index=0&id=2907dded&scoped=true&lang=css"
import "./ImpressPage.vue?vue&type=style&index=1&id=2907dded&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2907dded"]])

export default __exports__